import { render } from "./index.vue?vue&type=template&id=0051aba9&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./style/index.less?vue&type=style&index=0&id=0051aba9&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0051aba9"],['__file',"src/views/chapter-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0051aba9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0051aba9', __exports__)) {
    console.log('reload')
    api.reload('0051aba9', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0051aba9&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0051aba9', render)
  })

}


export default __exports__